import {
  DeleteOutlined as DeleteOutlinedAntd,
  FormOutlined as FormOutlinedAntd,
} from '@ant-design/icons';
import { Col as ColAntd, Form as FormAntd } from 'antd';
import styled from 'styled-components';

export const EditableField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Texto = styled.span``;

export const Paragrafo = styled.p`
  text-align: justify;
`;

export const Label = styled.b``;

export const DeleteOutlined = styled(DeleteOutlinedAntd)`
  color: #ff0000;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const FormOutlined = styled(FormOutlinedAntd)`
  color: #7bc372;
  font-size: 20px;
  padding: 0 10px;

  :hover {
    opacity: 0.6;
  }
`;

export const ColAdicionarFaixa = styled(ColAntd)`
  padding-bottom: 24px;
`;

export const ItemForm = styled(FormAntd.Item)`
  label {
    font-weight: bold;
    font-size: 14px !important;
    color: #000 !important;

    ::after {
      content: none;
    }
  }
`;
